export default function BrandNarrative() {
  return (
    <section className="py-16 md:py-24 px-6 md:px-12 bg-background-100">
      <div className="max-w-4xl mx-auto text-center">
        <span className="inline-block px-4 py-1.5 border border-foreground-300/40 rounded-full text-foreground-600 text-xs font-semibold uppercase tracking-wider mb-6">
          Why OOPBuy Spreadsheet
        </span>

        <h2 className="font-heading text-3xl md:text-5xl lg:text-6xl font-light leading-snug md:leading-tight text-foreground-950">
          Streamline Your{' '}
          <span className="relative inline-flex items-center gap-1">
            <i className="ri-database-2-line text-primary-500 w-8 h-8 md:w-10 md:h-10 flex items-center justify-center"></i>
          </span>{' '}
          Sourcing Workflow{' '}
          <span className="relative inline-flex items-center gap-1">
            <i className="ri-shopping-bag-3-line text-accent-500 w-8 h-8 md:w-10 md:h-10 flex items-center justify-center"></i>
          </span>{' '}
          With Smart Data{' '}
          <span className="relative inline-flex items-center gap-1">
            <i className="ri-line-chart-line text-secondary-500 w-8 h-8 md:w-10 md:h-10 flex items-center justify-center"></i>
          </span>
        </h2>

        <p className="mt-8 text-foreground-600 text-sm md:text-base max-w-2xl mx-auto leading-relaxed">
          Traditional product sourcing scatters your data across multiple tabs, emails, and spreadsheets. The OOPBuy Spreadsheet replaces chaos with one filterable bridge mapped to 14 live product categories — a structured product tracking methodology built for e-commerce workflows.
        </p>

        <div className="grid grid-cols-1 sm:grid-cols-3 gap-6 mt-12">
          <div className="bg-background-50 rounded-xl p-6 text-center">
            <div className="w-14 h-14 mx-auto rounded-full bg-primary-100 flex items-center justify-center mb-4">
              <i className="ri-filter-3-line text-primary-600 text-xl w-6 h-6 flex items-center justify-center"></i>
            </div>
            <h3 className="font-heading text-lg font-semibold text-foreground-950">14 Categories</h3>
            <p className="mt-2 text-sm text-foreground-600">Filter and browse across shoes, apparel, accessories, and more from one hub</p>
          </div>
          <div className="bg-background-50 rounded-xl p-6 text-center">
            <div className="w-14 h-14 mx-auto rounded-full bg-accent-100 flex items-center justify-center mb-4">
              <i className="ri-shield-check-line text-accent-600 text-xl w-6 h-6 flex items-center justify-center"></i>
            </div>
            <h3 className="font-heading text-lg font-semibold text-foreground-950">Verified Data</h3>
            <p className="mt-2 text-sm text-foreground-600">Structured product tracking methodology based on real operational logic</p>
          </div>
          <div className="bg-background-50 rounded-xl p-6 text-center">
            <div className="w-14 h-14 mx-auto rounded-full bg-secondary-100 flex items-center justify-center mb-4">
              <i className="ri-rocket-2-line text-secondary-600 text-xl w-6 h-6 flex items-center justify-center"></i>
            </div>
            <h3 className="font-heading text-lg font-semibold text-foreground-950">Instant Access</h3>
            <p className="mt-2 text-sm text-foreground-600">Jump directly to live product pages on kaspreadsheet.com with one click</p>
          </div>
        </div>
      </div>
    </section>
  );
}